module.exports = __webpack_public_path__ + "img/teddys_binoculars.d313fa3d.jpg";